
import produce from 'immer'
import moment from 'moment-timezone'
import qs from 'qs'


function getDatePeriod(value) {
  switch (value) {
    case 'TODAY':
      return {
        startDate: moment().tz('est').startOf('day'),
        endDate: moment().tz('est').endOf('day')
      }

    case 'YESTERDAY':
      return {
        startDate: moment().tz('est').add(-1, 'days').startOf('day'),
        endDate: moment().tz('est').add(-1, 'days').endOf('day'),
      }

    case 'LAST_7_DAYS':
      return {
        startDate: moment().tz('est').add(-7, 'days').startOf('day'),
        endDate: moment().tz('est').endOf('day')
      }
    case 'LAST_14_DAYS':
      return {
        startDate: moment().tz('est').add(-14, 'days').startOf('day'),
        endDate: moment().tz('est').endOf('day'),
      }
    case 'LAST_30_DAYS':
      return {
        startDate: moment().tz('est').add(-30, 'days').startOf('day'),
        endDate: moment().tz('est').endOf('day')
      }
    case 'THIS_MONTH':
      return {
        startDate: moment().tz('est').startOf('month').startOf('day'),
        endDate: moment().tz('est').endOf('day')
      }
    case 'LAST_MONTH':
      return {
        startDate: moment().tz('est').add(-1, 'months').startOf('month').startOf('day'),
        endDate: moment().tz('est').add(-1, 'months').endOf('month').endOf('day')
      }
    case 'THIS_YEAR':
      return {
        startDate: moment().tz('est').startOf('year').startOf('month').startOf('day'),
        endDate: moment().tz('est').endOf('day')
      }
      case 'ALL_TIME':
        return {
          startDate: moment().tz('est').add(-10, 'year'),
          endDate: moment().tz('est').endOf('day')
        }
    case 'CUSTOM':
      return {  }
    default:
      throw new Error('invalid date range')
  }
}


export function setStateFromQS(state, draft) {
  if (window.location.pathname !== '/insights')
    return 0

  const queryParams = qs.parse(window.location.search.replace('?', ''))

  if (queryParams.analyst) {
    draft.analyst.value = queryParams.analyst
  }
  if (queryParams.internal) {
    draft.internal.value = queryParams.internal
  }
  if (queryParams.spend_from) {
    // draft.spend.value = draft.spend.value || {}
    draft.spend.value.from = parseInt(queryParams.spend_from)
  }
  if (queryParams.title) {
    draft.title.value = queryParams.title
  }
  if (queryParams.text) {
    draft.text.value = queryParams.text
  }
  if (queryParams.platform) {
    draft.platform.value = queryParams.platform
  }
  if (queryParams.ad) {
    draft.ad.value = queryParams.ad
  }
  if (queryParams.datePeriod) {
    draft.datePeriod = queryParams.datePeriod
  }
  if (queryParams.prefix) {
    draft.prefix.value = queryParams.prefix
  }
  if (queryParams.startDate) {
    draft.startDate = moment(queryParams.startDate)
  }
  if (queryParams.endDate) {
    draft.endDate = moment(queryParams.endDate)
  }
  if (queryParams.articlecode) {
    const parts = queryParams.articlecode.split('-')
    if (parts.length > 4) {
      draft.ad.value = parts[4]
    } else {
      draft.ad.value = queryParams.articlecode
    }
  }
  return (Object.entries(queryParams).length > 0 )
}

const DefaultFiltersState = {
  analyst: {field: 'analyst', value: '', include: true},
  internal: {field: 'internal', value: 'ANY', include: true},
  spend: { field: 'spend', value: {from: 0, to: null}},
  title: { field: 'title', value: '', include: true },
  text: { field: 'text', value: '', include: true },
  platform: { field: 'platform', value: '', include: true },
  ad: { field: 'name', value: '', include: true },
  datePeriod: 'THIS_YEAR',
  prefix: { field: 'prefix', value: '', include: true },
  startDate: moment().tz('est').startOf('year').startOf('month').startOf('day'),
  endDate: moment().tz('est').endOf('day')
}

export function filtersReducer(state = DefaultFiltersState, event) {
  switch (event.type) {
    case 'updateFilter': {
      const { field, value } = event
      return produce(state, (draft) => {
        if (value !== null && typeof value === 'object') {
          draft[field].value = {...state[field].value, ...value}
        }
        else
        {
          draft[field].value = value
        }
      })
    }
    case 'searchPanelMounted':
     // getBusinesses().then((xs) => store.dispatch({ type: 'gotBusinesses', xs: prepareBusinesses(xs) }))
      return state
    case 'gotBusinesses':
      return produce(state, (draft) => {
        draft.businesses = event.xs
      })
    case 'updateDatePeriod':
      return produce(state, (draft) => {
        const { startDate, endDate } = getDatePeriod(event.datePeriod)
        draft.datePeriod = event.datePeriod
        if (startDate && endDate) {
          draft.startDate = startDate
          draft.endDate = endDate
        }

      })
    case 'updateCustomDate':
      return produce(state, (draft) => {
        draft[event.field] = moment(event.date)
      })
    case 'initFromQS': {
      const ns = produce(state, (draft) => {
        const isModified = setStateFromQS(state, draft)
        if (isModified) {
          setTimeout(() => event.store.dispatch({
            type: 'triggerSearch',
            filters: ns,
            sortField: 'spend',
            isSortAsc: false
          }), 10)
        }
      })


      return ns;
    }
    case 'triggerSearch': {
      window.history.pushState({}, '', buildUrl(state))
      return state
    }
    default:
      return state
  }
}

function buildUrl(state) {
  const {
    analyst: { value: analyst },
    internal: { value: internal },
    spend: { value: spend },
    title: { value: title },
    text: { value: text },
    platform: {  value: platform },
    ad: { value: ad },
    datePeriod,
    prefix: {  value: prefix },
    startDate,
    endDate
  } = state
  return `/insights?analyst=${analyst??''}&internal=${internal??''}&spend_from=${spend.from??''}&title=${title}&text=${text}&platform=${platform}&ad=${ad}&datePeriod=${datePeriod}&prefix=${prefix}&startDate=${startDate&&startDate.format('YYYY-MM-DD')}&endDate=${endDate&&endDate.format('YYYY-MM-DD')}`
}
